import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const GenerateAllSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 24px;
  border-top: 2px solid #e5e7eb;
  background-color: #ffffff;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
`

export const GenerateAllButton = styled.button`
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus:not(:disabled) {
    outline: none;
    box-shadow:
      0 0 0 3px rgba(79, 70, 229, 0.2),
      0 4px 12px rgba(79, 70, 229, 0.3);
  }

  &:disabled {
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }
`
